/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locale/en';
// import fr from '../locale/fr';
import nl from '../locale/nl';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en,
            nl,
        },
        lng: 'nl',
        fallbackLng: 'nl',
        debug: process.env.NODE_ENV !== 'production',
        ns: ['common', 'message', 'navbar', 'home', 'contact', 'shoppage', 'shoppingcart', 'addressform', 'advertisement', 'checkout', 'photoUpload'],
        defaultNS: 'message',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
        },
        react: {
            useSuspense: false
        },
    });
export default i18n;


